import { MARKETING_PAGES } from "./attributionPages.js";
export const MAX_AGE_SECONDS = 90 * 24 * 60 * 60;
const FIELDS = {
  source: 100, medium: 100, campaign: 255, campaign_id: 255,
  term: 255, content: 255, referrer_host: 255, landing_path: 2048,
};
export const PARAMETERS = {
  utm_source: "source", utm_medium: "medium", utm_campaign: "campaign",
  utm_id: "campaign_id", utm_term: "term", utm_content: "content",
};

function clean(value, limit) {
  if (typeof value !== "string") return null;
  const result = [...value].filter((character) => {
    const code = character.charCodeAt(0);
    return code > 31 && code !== 127;
  }).join("").trim();
  return result && result.length <= limit ? result : null;
}

export function label(value, limit) {
  return clean(value, limit)?.toLowerCase()
    .replace(/[^a-z0-9._-]+/g, "_").replace(/^_+|_+$/g, "") || null;
}

export function hostname(value) {
  const host = clean(value, 255)?.toLowerCase().replace(/\.$/, "");
  // Never accept a URL, credentials, port, IP address, or path as a hostname.
  if (!host || host.length > 253 || !host.includes(".") || /^[\d.]+$/.test(host)) return null;
  return host.split(".").every((part) =>
    /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(part),
  ) ? host : null;
}

export function validTimestamp(value, now) {
  if (typeof value !== "string" ||
      !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return null;
  const [year, month, day] = value.slice(0, 10).split("-").map(Number);
  const calendarDate = new Date(0);
  calendarDate.setUTCFullYear(year, month - 1, day);
  if (calendarDate.getUTCFullYear() !== year || calendarDate.getUTCMonth() !== month - 1 ||
      calendarDate.getUTCDate() !== day) return null;
  const time = Date.parse(value);
  if (!Number.isFinite(time) || time < now - MAX_AGE_SECONDS * 1000 || time > now + 300000) return null;
  return new Date(time).toISOString();
}

export function validateTouch(candidate, now = Date.now()) {
  if (!candidate || typeof candidate !== "object" || Array.isArray(candidate)) return null;
  const captured_at = validTimestamp(candidate.captured_at, now);
  if (!captured_at) return null;
  const touch = {};
  for (const [field, limit] of Object.entries(FIELDS)) {
    const value = ["source", "medium"].includes(field)
      ? label(candidate[field], limit) : clean(candidate[field], limit);
    if (value) touch[field] = value;
  }
  if (touch.referrer_host) {
    const host = hostname(touch.referrer_host);
    if (host) touch.referrer_host = host;
    else delete touch.referrer_host;
  }
  if (touch.landing_path) {
    try {
      const path = new URL(touch.landing_path, "https://africaspocket.com").pathname;
      if (path.length <= FIELDS.landing_path) touch.landing_path = path;
      else delete touch.landing_path;
    } catch { delete touch.landing_path; }
  }
  if (candidate.site === "m") {
    touch.site = "m";
    delete touch.landing_path;
    if (Object.hasOwn(MARKETING_PAGES, candidate.page_code)) touch.page_code = candidate.page_code;
  }
  // A timestamp/path alone is not acquisition evidence.
  if (!["source", "medium", "campaign", "campaign_id", "term", "content", "referrer_host"].some((key) => touch[key])) return null;
  return { ...touch, captured_at };
}
